import {fetch} from '../utils/fetch';
import { casaApiUrl } from 'configs/casa-api'
import queryString from 'query-string'

function getTotalSales (filter) {
  let {startDate, endDate, storeNames, interval, brandName, businessName} = filter
  let startDateParam = startDate.format('YYYY-MMM-DD')
  let endDateParam = endDate.format('YYYY-MMM-DD')
  let query = queryString.stringify({
    stores: storeNames
  }, {arrayFormat: 'bracket'})
  return fetch(`${casaApiUrl}/users/sales-analytics/total-sales/${brandName}/${businessName}/${startDateParam}/${endDateParam}/${interval}?${query}`, {
    credentials: 'include',
    method: 'GET'
  }).then(res => {
    if (res.status != 200) {
      return null;
    }
    return res.json()
  })
}

function getSalesHierarchySplit (filter) {
  let {startDate, endDate, storeNames, brandName, businessName} = filter
  let startDateParam = startDate.format('YYYY-MMM-DD')
  let endDateParam = endDate.format('YYYY-MMM-DD')
  let query = queryString.stringify({
    stores: storeNames
  }, {arrayFormat: 'bracket'})
  return fetch(`${casaApiUrl}/users/sales-analytics/sales-hierarchy-split/${brandName}/${businessName}/${startDateParam}/${endDateParam}?${query}`, {
    credentials: 'include',
    method: 'GET'
  }).then(res => {
    if (res.status === 404) {
      return null
    }
    return res.json()
  })
}

export default {
  getTotalSales, getSalesHierarchySplit
}



// WEBPACK FOOTER //
// ./src/services/sales-analytics-service.js